import React, { Component } from 'react';
import i from '../imports';
import navigation from '../navigation';
import ContainerDimensions from 'react-container-dimensions';
import Dimensions from 'react-dimensions';

const containerStyle = {
    margin: 25,
    padding: "10px 18px 10px 10px",
    position: "relative",
    color: "black"
}

const contentStyle = {
    opacity: 1
}

const imageStyle = {
    borderRadius: 4,
}

const titleStyle = {
    color: "#FF5560",
    fontSize: 17,
    fontWeight: "bold"
}

const blogTextStyle = {
    fontSize: 15,
    paddingTop: 10,
    paddingBottom: 10,
    lineHeight: 1
}

const moreLink = {
    color: "#FF5563",
    textDecoration: "none",
    fontSize: 14,
    fontWeight: "bold"
}

const backroundBlockStyle = {
    position: "absolute",
    left: 0,
    top: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "white",
    opacity: 0.8,
    borderRadius: 7
}

class BlogCard extends Component {
    render() {
        let item = this.props.item;
        let blogUrl = navigation.filter(n => n.name == "blog")[0] || ""
        return (
            <div style={Object.assign({}, containerStyle, this.props.containerStyle)}>
                <div style={Object.assign({}, backroundBlockStyle, this.props.bgStyle)} />
                <i.PureGridProvider gutterSize={0}>
                    <i.Container >
                        <i.Row style={{ ...contentStyle }}>
                            <i.Col xs={4} align="center" style={{ paddingLeft: 10, paddingRight: 10 }} >
                                <img src={item.thumbnail} style={imageStyle} width="100%" height="100%" />
                            </i.Col>
                            <i.Col xs={8} align="left" style={{ paddingLeft: 10 }} >
                                <div style={titleStyle} >{item ? item.title : ""}</div>
                                <div style={blogTextStyle} >
                                    <div style = {{overflow: "hidden", height:90}}>                    
                                        {item ? item.short_text : ""}
                                    </div>
                                </div>
                            </i.Col>
                        </i.Row>
                        <i.Row>
                            <i.Col xs={6} align="left" style={{paddingLeft: 10}}>
                                <div style={{ fontSize: 14 }}>{(new Date(item.date)).toLocaleDateString("ru-RU")}</div>
                            </i.Col>
                            <i.Col xs={6} align="right">
                                <div style={{ textAlign: "right" }}><i.NavLink style={moreLink} to={i.Utils.locUrl(i.Utils.createBlogUrl(item))} /*.locUrl(blogUrl + "/" + item.name)*/ >Read ></i.NavLink></div>
                            </i.Col>
                        </i.Row>
                    </i.Container>
                </i.PureGridProvider>
            </div>
        );
    }
}

export default BlogCard;